/**
 * Chunk-load-shaped failures, across Chrome / Safari / Firefox phrasings.
 *
 * A tab still running the previous deploy asks for a hashed chunk the new
 * deploy no longer publishes. That is an app-update event, never a code
 * defect, so it must route to the update pipeline instead of the 404 page.
 *
 * The second group is module LINK failure: an old chunk importing a name a
 * fresh chunk no longer exports. It is gated on a `.js` module reference so a
 * genuinely broken import in our own source still surfaces as an error.
 * Safari's binding-name phrasing carries no URL, but it can only ever come
 * from module linking, so it is matched on its own.
 */
const CHUNK_MESSAGE_PATTERNS = [
  'failed to fetch dynamically imported module',
  'error loading dynamically imported module',
  'importing a module script failed',
  'is not a valid javascript mime type',
  'loading chunk',
  'loading css chunk',
  'unable to preload css',
];

const MODULE_LINK_PATTERNS = [
  'does not provide an export named',
  "doesn't provide an export named",
];

export function isChunkLoadError(error: unknown): boolean {
  const message = (error as { message?: string })?.message?.toLowerCase() || '';
  if (!message) return false;
  if (CHUNK_MESSAGE_PATTERNS.some((pattern) => message.includes(pattern))) return true;
  if (message.includes('importing binding name') && message.includes('is not found')) return true;
  return message.includes('.js') && MODULE_LINK_PATTERNS.some((pattern) => message.includes(pattern));
}
